import nexus from '@db2b/nexus-js'
import Vue from 'vue'

let defaultPreferences = {
  notifications: {
    devices: [],
    type: 'web'
  },
  reminders: {
    notifications: [5, 15],
    show_since_days: 30,
    meeting_display_mode: 'monthly'
  },
  task_lists: {
    display_mode: 'floating',
    always_displayed: false
  }
}

const state = {
  all: []
}

const getters = {
  current: (state) => {
    let vm = new Vue({data: {current: {
      payload: defaultPreferences
    }}})

    vm.$watch(() => {
      return state.all[0]
    }, (current) => {
      vm.current.payload = Object.assign({}, vm.current.payload, current.payload)
    })

    return vm.current
  }
}

const actions = {
  load ({commit, state}) {
    return nexus.get('account', 'preferences/commercial')
      .then(response => {
        state.all = response.data.data
      })
  },
  update (context, {preferences}) {
    return nexus.post('account', 'preferences/commercial', {payload: preferences})
  }
}

const mutations = {
  currentPreferencesLoaded (state, {preferences}) {
    state.all.push(preferences)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/account/user_preferences.js